import React, { Component } from "react";
import { answerBubbleStyle, answerBubbleStyleMobile } from "../../utils/styles";

import { QuestionComponent, QuestionComponentButton } from "./OnboardingStyles";
export default class Name extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: "",
      lastName: "",
      submitted: false,
    };
  }

  handleChange = e => {
    if (e.target.name === "firstname") {
      this.setState({ firstName: e.target.value });
    }

    if (e.target.name === "lastname") {
      this.setState({ lastName: e.target.value });
    }
  };

  handleKeyPressed(e) {
    if (e.key === "Enter" && this.state.firstName && this.state.lastName) {
      e.preventDefault();
      this.handleSubmit();
    }
  }

  handleSubmit() {
    if (this.state.firstName && this.state.lastName) {
      this.setState({ submitted: true });
      this.props.triggerNextStep({
        value: this.state.firstName + ":" + this.state.lastName
      });
    }
  }

  render() {
    if (this.state.submitted) {
      return (
        <div
          style={
            document.documentElement.clientWidth <= 812
              ? answerBubbleStyleMobile
              : answerBubbleStyle
          }
        >
          {this.state.firstName + " " + this.state.lastName}
        </div>
      );
    }
    const firstnameFilled = this.state.firstName ? "filled" : "";
    const lastnameFilled = this.state.lastName ? "filled" : "";
    const buttonDisabled = firstnameFilled && lastnameFilled ? "" : "disabled";
    return (
      <QuestionComponent className="container question-component__inner right">
        <div className={"question__responses textbox " + firstnameFilled}>
          <input
            type="text"
            name="firstname"
            placeholder="First Name"
            value={this.state.firstName}
            onChange={this.handleChange}
            onKeyPress={this.handleKeyPressed.bind(this)}
          />
        </div>
        <div className={"question__responses textbox " + lastnameFilled}>
          <input
            type="text"
            name="lastname"
            placeholder="Last Name"
            value={this.state.lastName}
            onChange={this.handleChange}
            onKeyPress={this.handleKeyPressed.bind(this)}
          />
        </div>
        <QuestionComponentButton
          type="button"
          className={"ha-btn-circle mr-1 " + buttonDisabled}
          onClick={this.handleSubmit.bind(this)}
          style={{marginRight:'3px'}}
        >
          <i className="fa fa-check" />
        </QuestionComponentButton>
      </QuestionComponent>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/onboarding/Name.js